export default __webpack_public_path__ + "static/media/argo.eaf4efb2.png";